import { Target, BarChart2, Shield, Zap, ChevronRight } from "lucide-react";

export default function HoeHetWerkt() {
  const steps = [
    { num: "01", icon: <Target size={28} className="text-[#C9A84C]" />, title: "Kies je product", desc: "Bepaal welk product het beste bij jouw doel past: schema, cursus of het complete pakket." },
    { num: "02", icon: <BarChart2 size={28} className="text-[#C9A84C]" />, title: "Kies je variant of doel", desc: "Selecteer je trainingsdoel of pakketgrootte voor een gepersonaliseerde ervaring." },
    { num: "03", icon: <Shield size={28} className="text-[#C9A84C]" />, title: "Reken veilig af", desc: "Betaal eenmalig via een veilige betaalpagina. Geen verborgen kosten, geen abonnement." },
    { num: "04", icon: <Zap size={28} className="text-[#C9A84C]" />, title: "Start direct", desc: "Je krijgt onmiddellijk toegang. Download je schema of start de eerste les vandaag nog." },
  ];
  return (
    <section data-testid="how-it-works" className="py-20 lg:py-28 bg-[#0d0d0d]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="overline mb-3">Simpel proces</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">Hoe het werkt</h2>
          <p className="text-zinc-400">Van keuze tot resultaat in vier stappen</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => (
            <div key={step.num} className="step-card group">
              <div className="step-num">{step.num}</div>
              <div className="step-icon-wrap">{step.icon}</div>
              <h3 className="text-white font-bold text-lg mb-2">{step.title}</h3>
              <p className="text-zinc-400 text-sm leading-relaxed">{step.desc}</p>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 -right-3 z-10">
                  <ChevronRight size={20} className="text-[#C9A84C]/40" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
